import { ROUTES } from './routes'

/** `/_/support/tickets/{ticketId}`: the link the Support e-mails carry (F-82). */
export const SUPPORT_TICKET_PREFIX = ROUTES.supportTicket
export const isSupportTicketPath = (path: string): boolean => path.startsWith(SUPPORT_TICKET_PREFIX)
export const supportTicketIdOf = (path: string): string =>
  decodeURIComponent(path.split('?')[0].slice(SUPPORT_TICKET_PREFIX.length).split('/')[0] || '')
